import React from "react";
import { PlusOutlined } from "@ant-design/icons";

export default function AddBetweenButton({ onClick, active }) {
  return (
    <div style={{ display: "flex", justifyContent: "center", padding: "8px 0" }}>
      <button
        type="button"
        onClick={onClick}
        style={{
          background: active ? "#eff6ff" : "none",
          border: `1px dashed ${active ? "#1890ff" : "#d1d5db"}`,
          borderRadius: 6,
          padding: "4px 14px",
          cursor: "pointer",
          fontSize: 12,
          color: active ? "#1890ff" : "#9ca3af",
          display: "flex",
          alignItems: "center",
          gap: 6,
          transition: "all 0.15s ease",
          fontWeight: active ? 600 : 400,
        }}
        onMouseEnter={(e) => {
          if (!active) {
            e.currentTarget.style.borderColor = "#1890ff";
            e.currentTarget.style.color = "#1890ff";
            e.currentTarget.style.background = "#eff6ff";
          }
        }}
        onMouseLeave={(e) => {
          if (!active) {
            e.currentTarget.style.borderColor = "#d1d5db";
            e.currentTarget.style.color = "#9ca3af";
            e.currentTarget.style.background = "none";
          }
        }}
      >
        <PlusOutlined style={{ fontSize: 11 }} />
        {active ? "Insert Block Here" : "Add Section"}
      </button>
    </div>
  );
}
